interface IProps {
  id: number;
  name: string;
}

export const collectObjectSelect = (arr: IProps[]): { label: string; value: string }[] => {
  return arr.map(({ id, name }) => ({ value: `${id}`, label: name }));
};
